module.exports = __webpack_public_path__ + "static/images/pos2img.b0578ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/pos2img.jpg
// module id = XzAS
// module chunks = 1